// src/hooks/useDeletedStillActive.js
import { useState, useEffect } from "react";
import { fetchDeletedStillActive } from "./plateService";

const POLL_MS = 60000;

/**
 * Deleted plates that can still open a gate in this area (see the API endpoint
 * .../license-plates/deleted-still-active), polled every minute like the sync status.
 * null until loaded or when disabled (roles without plate access).
 */
export function useDeletedStillActive(areaId, enabled = true) {
  const [plates, setPlates] = useState(null);

  useEffect(() => {
    if (!areaId || !enabled) {
      setPlates(null);
      return;
    }

    let cancelled = false;
    const poll = async () => {
      try {
        const list = await fetchDeletedStillActive(areaId);
        if (!cancelled) setPlates(list);
      } catch (err) {
        console.error("Error fetching deleted plates still active", err);
      }
    };

    poll();
    const interval = setInterval(poll, POLL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, [areaId, enabled]);

  return plates;
}
